<template>
  <div class="acomodar">
    <Mantenimiento/>
  </div>
</template>

<script>
import Mantenimiento from '@/components/ModContabilidad/MantCuenta.vue'
export default {
  name: 'SolimanoLogMantenimiento',
components:{
    Mantenimiento
},
  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  created(){
this.cambiarEstadoNavbar()
  },

  methods: {
    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },
  },
};
</script>

<style scoped>
.acomodar {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  margin-top: 1%;
  margin-bottom: 1%;
  padding-bottom: 2%;
  width: 100%;
  background: rgb(255, 255, 255);
  margin-left: 1%;
  margin-right: 1%;
  height: auto;
  border-radius: 10px 10px 10px 10px;
  overflow-x: hidden;
  overflow-y: hidden;
}
</style>